import $ from 'jquery';
import showOnScroll from '@zerofool/show-on-scroll';

$(function() {
	showOnScroll('.arrow-box');
});